// useSessionCheck.js
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../actions/auth.js";

const useSessionCheck = (setNotificationMessage, setOpen) => {
    const dispatch = useDispatch();

    useEffect(() => {
        let intervalId;
        
        const checkSessionExpiration = () => {
            const now = Date.now();
            const tokenExp = localStorage.getItem("tokenExp");
            const authTokenExp = localStorage.getItem("authTokenExp");

            let sessionWillExpireSoon = false;
            let sessionExpired = false;

            const timeBeforeExpiration = 5 * 60 * 1000; // 5 minutes en millisecondes
            let timeRemaining = 0;

            // Calculer le temps restant avant l'expiration du token (en millisecondes)
            if (tokenExp) {
                timeRemaining = parseInt(tokenExp, 10) - now;
            } else if (authTokenExp) {
                timeRemaining = parseInt(authTokenExp, 10) - now;
            }

            // Si le temps restant est inférieur à 5 minutes, on considère que la session va expirer bientôt
            if (timeRemaining <= timeBeforeExpiration && timeRemaining > 0) {
                sessionWillExpireSoon = true;
            }

            // Calculer les minutes restantes
            const minutesRemaining = Math.floor(timeRemaining / (60 * 1000)); // Convertir en minutes

            // Afficher un message personnalisé selon les minutes restantes
            if (sessionWillExpireSoon && !sessionExpired) {
                if (minutesRemaining > 1) {
                    setNotificationMessage(`Votre session va expirer dans ${minutesRemaining} minutes.`);
                } else if (minutesRemaining === 1) {
                    setNotificationMessage("Votre session va expirer dans 1 minute.");
                } else if (timeRemaining <= 60000) {  // Moins d'une minute restante
                    setNotificationMessage("Vous allez être déconnecté sous peu.");
                }

                setOpen(true);
            }

            // Déconnexion lorsque le temps restant est à 0
            if (timeRemaining <= 0) {
                sessionExpired = true;
            }

            if (sessionExpired) {
                setNotificationMessage("");  // Vide le message de la notification
                setOpen(false);  // Fermer la notification
                dispatch(logoutUser());
            }

            // Si le temps restant est inférieur à 1 minute, on passe à une vérification toutes les secondes
            if (timeRemaining <= 60000 && !sessionExpired) {
                clearInterval(intervalId);  // Arrêter la vérification toutes les 60 secondes
                intervalId = setInterval(checkSessionExpiration, 1000);  // Passer à une vérification toutes les secondes
            }
        };

        intervalId = setInterval(checkSessionExpiration, 60000);  // Vérification toutes les 60 secondes
        checkSessionExpiration();  // Vérification immédiate au chargement

        return () => clearInterval(intervalId);
    }, [dispatch, setNotificationMessage, setOpen]);
};
export default useSessionCheck;